module.exports = __webpack_public_path__ + "static/media/2024 FC2_Summary Of Benefits for PBP 003_English.2b65f2b2.pdf";